export enum ECollectionSort {
  NEW = 'new',
  BESTSELLER = 'bestseller',
  PRICE_ASC = 'price-asc',
  PRICE_DESC = 'price-desc',
  PERCENT = 'percent',
}

export const COLLECTION_SORT_LABELS: Record<ECollectionSort, string> = {
  [ECollectionSort.BESTSELLER]: 'bestseller',
  [ECollectionSort.NEW]: 'new',
  [ECollectionSort.PRICE_ASC]: 'price_asc',
  [ECollectionSort.PRICE_DESC]: 'price_desc',
  [ECollectionSort.PERCENT]: 'percent',
}

export const sortedAttributeCardsUnderwear = [
  {
    _id: 'brief-tam-giac',
    title: 'collection_page.card_underwear.brief_tam_giac.label',
    sub_title: 'collection_page.card_underwear.brief_tam_giac.description',
    icon: '',
    seo_alias: 'brief-tam-giac',
    product_attribute_id: '',
    updated_at: new Date(),
    created_at: new Date(),
    image: '/image/April2024/mceclip0_74.png',
    image_hover: '/image/August2023/mceclip1_68.png',
    short_description: null,
    sort: 0,
  },
  {
    _id: 'boxer-trunk',
    title: 'collection_page.card_underwear.boxer_trunk.label',
    sub_title: 'collection_page.card_underwear.boxer_trunk.description',
    icon: '',
    seo_alias: 'boxer-trunk',
    product_attribute_id: '',
    updated_at: new Date(),
    created_at: new Date(),
    sort: 0,
    image: '/image/April2024/mceclip5_54.png',
    image_hover: '/image/August2023/mceclip4_52.png',
    short_description: null,
  },

  {
    _id: 'brief-boxer-dang-dai',
    title: 'collection_page.card_underwear.brief_boxer_dang_dai.label',
    sub_title:
      'collection_page.card_underwear.brief_boxer_dang_dai.description',
    icon: '',
    seo_alias: 'brief-boxer-dang-dai',
    product_attribute_id: '',
    updated_at: new Date(),
    created_at: new Date(),
    image: '/image/April2024/mceclip4_46.png',
    image_hover: '/image/August2023/mceclip6_22.png',
    short_description: null,
    sort: 0,
  },

  {
    _id: 'boxer-shorts',
    title: 'collection_page.card_underwear.boxer_shorts.label',
    sub_title: 'collection_page.card_underwear.boxer_shorts.description',
    icon: '',
    seo_alias: 'boxer-shorts',
    product_attribute_id: '',
    updated_at: new Date(),
    created_at: new Date(),
    image: '/image/April2024/mceclip3_56.png',
    image_hover: '/image/October2023/mceclip0_80.png',
    short_description: null,
    sort: 0,
  },
  {
    _id: 'long-leg',
    title: 'collection_page.card_underwear.long_leg.label',
    sub_title: 'collection_page.card_underwear.long_leg.description',
    icon: '',
    seo_alias: 'long-leg',
    product_attribute_id: '',
    updated_at: new Date(),
    created_at: new Date(),
    image: '/image/April2024/mceclip2_84.png',
    image_hover: '/image/September2023/mceclip14.jpg',
    short_description: null,
    sort: 0,
  },
]
